import $ from "jquery";
import "slick-carousel";

class Carousel {

    run() {
        this.ready();
    }

    ready() {
        // SLICKS CAROUSEL

        const nextBtn = "<div class='a-right control-c next slick-next'><svg width='44px' height='15px' viewBox='0 0 44 15' version='1.1'><g id='resolve' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='1.homepage-resolve' transform='translate(-1280.000000, -4007.000000)'' fill='#000000' fill-rule='nonzero'><g id='arrow-pointing-to-right-copy-6' transform='translate(1280.000000, 4007.000000)'><path d='M43.7009186,6.78331322 L37.1662993,0.296817969 C36.7676059,-0.0989393229 36.1210053,-0.0989393229 35.7223118,0.296817969 C35.3235367,0.692656341 35.3235367,1.33433288 35.7223118,1.73017126 L40.5139031,6.48647498 L1.02103427,6.48647498 C0.457178304,6.48647498 0,6.94028641 0,7.49998986 C0,8.05961224 0.457178304,8.51350475 1.02103427,8.51350475 L40.5139031,8.51350475 L35.7224752,13.2698085 C35.3237,13.6656468 35.3237,14.3073234 35.7224752,14.7031618 C35.9217811,14.9009188 36.1831659,15 36.4444689,15 C36.705772,15 36.9670751,14.9009188 37.1664627,14.7031618 L43.7009186,8.21666651 C44.0996938,7.82082814 44.0996938,7.17915159 43.7009186,6.78331322 Z' id='Path'></path></g></g></g></svg></div>";
        const prevBtn = "<div class='a-left control-c prev slick-prev'><svg width='44px' height='15px' viewBox='0 0 44 15'><g id='resolve' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='4.prodotto-B-resolve' transform='translate(-112.000000, -2869.000000)' fill='#000000'><g id='arrow-pointing-to-right-copy-7' transform='translate(134.000000, 2876.500000) scale(-1, 1) translate(-134.000000, -2876.500000) translate(112.000000, 2869.000000)'><path d='M43.7009186,6.78331322 L37.1662993,0.296817969 C36.7676059,-0.0989393229 36.1210053,-0.0989393229 35.7223118,0.296817969 C35.3235367,0.692656341 35.3235367,1.33433288 35.7223118,1.73017126 L40.5139031,6.48647498 L1.02103427,6.48647498 C0.457178304,6.48647498 0,6.94028641 0,7.49998986 C0,8.05961224 0.457178304,8.51350475 1.02103427,8.51350475 L40.5139031,8.51350475 L35.7224752,13.2698085 C35.3237,13.6656468 35.3237,14.3073234 35.7224752,14.7031618 C35.9217811,14.9009188 36.1831659,15 36.4444689,15 C36.705772,15 36.9670751,14.9009188 37.1664627,14.7031618 L43.7009186,8.21666651 C44.0996938,7.82082814 44.0996938,7.17915159 43.7009186,6.78331322 Z' id='Path'></path></g></g></g></svg></div>";

        // Carousel: Only Dots [data-carousel="only-dots"]
        $("[data-carousel='only-dots']").each(function () {
            $(this).slick({
                autoplay: true,
                infinite: true,
                autoplaySpeed: 5000,
                speed: 200,
                slidesToShow: 1,
                arrows: false,
                dots: true,
            });
        })

        //slick-method carousel
        $('.slick-method').on('init', function (event, slick) {
            $(".sliderTotalItems").append('<div class="slider-count"><p style="display: inline-flex"><span id="current" style="font-size: 36px;font-weight: bold;margin-right: 3px;">1</span> <span style="border-bottom: 4px solid #F9B233; display: flex;\n' + 'width: 50px;"></span> <span id="total" style="font-size: 18px;font-weight: bold;color: #B3B3B3;margin-left: 7px;">' + slick.slideCount + '</span></p></div>');
        });

        $('.slick-method').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: prevBtn,
            nextArrow: nextBtn,
            fade: false,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                    }
                },
            ]
        });

        $('.values-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots:true,
            fade: false,
        });
        $('.slider-video-about').slick({
            infinite: true,
            autoplay: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            dots:true,
            draggable:false,
            fade: false,
            responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },

            ]
        });

        $('.slick-method').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            // finally let's do this after changing slides
            $('.slider-count #current').html(currentSlide + 1);
        });

        $('.our-partners-carousel').slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            rows: 2,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
                {
                    breakpoint: 600,
                    settings: {
                        rows: 1,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        rows: 1,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: false,
                        arrows: true,
                        infinite: true,
                        prevArrow: prevBtn,
                        nextArrow: nextBtn,
                    }
                }
            ]
        });

        $('.certificate-info').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            swipeToSlide: true,
            dots: false,
            arrow: true,
            prevArrow: prevBtn,
            nextArrow: nextBtn,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        infinite: true,
                        slidesToShow: 1,
                        arrow: true,
                        dots: false,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false
                    }
                }
            ]
        });

        $(document).ready(function () {
            $('.carousel-for-clients').slick({
                dots: true,
                slidesPerRow: 3,
                rows: 2,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesPerRow: 2,
                        rows: 1,
                    }
                },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesPerRow: 1,
                            rows: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesPerRow: 1,
                            rows: 1,
                        }
                    }
                ]
            });
        });

        $('.our-achievement-carousel, .achievement-single-certificate').slick({
            dots: true,
            slidesPerRow: 2,
            rows: 2,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesPerRow: 2,
                    rows: 2
                }
            },
                {
                    breakpoint: 600,
                    settings: {
                        slidesPerRow: 3,
                        rows: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesPerRow: 1,
                        rows: 1,
                        dots: true,
                    }
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesPerRow: 1,
                        rows: 1,
                        dots: true,
                    }

                },
            ]
        });

        // Slick Carousel for Ergon Group page
        $(".case-study__carousel").each(function () {
            $(this).slick({
                autoplay: true,
                infinite: true,
                speed: 200,
                slidesToShow: 2,
                // slidesToScroll: 2,
                arrows: true,
                prevArrow: prevBtn,
                nextArrow: nextBtn,

                // the magic
                responsive: [{

                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                        dots: false
                    }

                }, {

                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                        dots: false
                    }

                }]
            });
        })

        $('.case-study__certificate').slick({
            infinite: false,
            slidesToShow: 2,
            // slidesToScroll: 2,
            arrows: true,

            responsive: [{

                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                    dots: false,
                    slidesToScroll: 1,
                }

            }, {

                breakpoint: 420,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }

            }]
        });


        $('.case-study__our-clients-carousel').slick({

            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            rows: 2,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
                {
                    breakpoint: 600,
                    settings: {
                        rows: 1,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        rows: 1,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: false,
                        arrows: true,
                        infinite: true,
                        prevArrow: prevBtn,
                        nextArrow: nextBtn,

                    }
                }
            ]
        });

        $('.two-col-carousel').each(function () {
            $(this).slick({
                // normal options...
                infinite: true,
                autoplay: true,
                speed: 200,
                slidesToShow: 2,
                dots: true,
                arrows: false,
                // the magic
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        arrows: true,
                        prevArrow: prevBtn,
                        nextArrow: nextBtn,
                    }

                }, {

                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.5,
                        dots: false,
                        arrows: true,
                        prevArrow: prevBtn,
                        nextArrow: nextBtn,
                        }

                }, {
                    breakpoint:500,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        arrows: true,
                        prevArrow: prevBtn,
                        nextArrow: nextBtn,
                    }
                },
                    {
                        breakpoint: 320,
                        settings: {
                            slidesToShow: 0.95,
                            dots: false,
                            arrows: true,
                            prevArrow: prevBtn,
                            nextArrow: nextBtn,
                        }

                    }
                ],
            });

            // create closure to cycle information
            let slideHeight;
            let moreHeights = [];

            if (location.href.lastIndexOf('/blog/') === -1) {
                // find every heights and push it in array
                $(this).find(".blog__carousel__slide").each(function () {
                    slideHeight = $(this).height();
                    moreHeights.push(slideHeight);
                })
                // Get highest value of array
                let highest = Math.max.apply(Math, moreHeights);
                // set the heights
                $(this).find(".blog__carousel__slide>div").each(function () {
                    $(this).height(highest + 50);
                })
            }
        });


        $('.posts-list__carousel').each(function () {
            $(this).slick({

                // normal options...
                infinite: false,
                slidesToShow: 1,
                dots: true,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            dots: true,
                            arrows: false,
                            slidesToShow:1,
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            dots: false,
                            slidesToShow: 1.2,
                        }
                    }]

            });

            // create closure to cycle information
            let slideHeight;
            let moreHeights = [];
            // find every heights and push it in array
            $(this).find(".posts-list__carousel__slide .post-tease").each(function () {
                slideHeight = $(this).height();
                moreHeights.push(slideHeight);
            })
            // Get highest value of array
            let highest = Math.max.apply(Math, moreHeights);
            // set the heights
            $(this).find(".posts-list__carousel__slide .post-tease").each(function () {
                $(this).removeClass("h-100");
                $(this).find(".btn").parent().addClass('btn-down');
                $(this).height(highest);
            })

        });

        $('.slider-hero').slick({
            infinite: false,
            slidesToShow: 1,
            dots: true,
            arrows: true,

        });

        $('.open-projects-carousel').slick({
            infinite: false,
            slidesToShow: 2,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1140,
                    settings: {
                        dots: true,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        dots: false,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        arrows: true,
                    }
                }]
        });

        $('.open-projects-landing-carousel').slick({
            infinite: false,
            slidesToShow: 3,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1140,
                    settings: {
                        dots: true,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        dots: false,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        arrows: true,
                    }
                }
            ]
        });

        //TIMELINE

        $('.timeline-slider').slick({
            infinite: false,
            adaptiveHeight: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            swipeToSlide: true,
            dots: true,
            arrow: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                        arrow: false,
                        dots: true,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        infinite: false,
                        slidesToShow: 2,
                        arrow: false,
                        dots: true,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false
                    }
                }
            ]
        });

        //blog page slider content adjuster
        const title_height = $('.twelve-col-tease .post-tease__title').height();
        var sub_title = $('.twelve-col-tease .post-tease__sub-title');
        if (title_height > 320) {
            sub_title.css('-webkit-line-clamp', 3)
        }
    }

}

const carousel = new Carousel();
export default carousel;
